const $ = require('cash-dom');

const CustomSelect = {
  init() {
    /*Triggers custom change event. Use $('.select-custom').on('change', function (e, value) {}); to catch */
    $(document).on('click', '.select-custom .selected', function () {
      $(this).closest('.select-custom').toggleClass('opened');

      let watcher = $(this).closest('.watch-select-custom');

      if (watcher.length) {
        let toggle = !!watcher.find('.select-custom.opened').length;

        watcher.toggleClass('select-custom-opened', toggle);
      }
    });

    $(document).on('click', '.select-custom .options .option', function (e) {
      if ($(this).attr('href') === '#') {
        e.preventDefault();
      }
      var title = $(this).html(),
        value = $(this).attr('data-value'),
        select = $(this).closest('.select-custom'),
        inp = select.find('input');

      select.find('.selected').html(title);

      if (inp.length) {
        inp.val(value);
      }

      select.removeClass('opened');

      select.trigger('change', value);

      if ($(this).closest('.watch-select-custom').length) {
        $(this).closest('.watch-select-custom').removeClass('select-custom-opened');
      }
    });

    $(document).on('click', '.select-custom-close', function () {
      $('.select-custom').removeClass('opened');

      if ($(this).closest('.watch-select-custom').length) {
        $(this).closest('.watch-select-custom').removeClass('select-custom-opened');
      }
    });
  },
};

module.exports = CustomSelect;

